import { Bar } from 'react-chartjs-2'
import { CHART_COLOURS, useChartTheme } from './SimpleLineChart'

export default function SimpleBarChart ({ labels, datasets, options }) {
  const mergedOptions = useChartTheme(options)

  datasets.forEach((dataset, i) => {
    dataset.backgroundColor = CHART_COLOURS[i % CHART_COLOURS.length]
    dataset.borderColor = dataset.backgroundColor
    dataset.borderWidth = 1
  })

  return (
    <Bar
      options={mergedOptions}
      data={{ labels, datasets }}
    />
  )
}
